import Vue, { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';
import CVueInstance from './CVueInstance';

@ComponentDecorator({
  props: {
    background: String,
    text: String,
    serviceName: String,
    productId: String,
  },
})

export default class CubeReviewsBlock extends CVueInstance {
  private Reviews: any[] | undefined | null = null;
  public mounted() {
    const self = this as any;

    let query = this.$firebase.firestore.collection('reviews').where('show', '==', true);
    if (self.serviceName !== undefined && self.serviceName !== null) {
      query = query.where('service', '==', self.serviceName);
    }
    if (self.productId !== undefined && self.productId !== null) {
      query = query.where('productId', '==', self.productId);
    }
    query.limit(5).get().then((prodDocs: any) => {
      let reviewList = [];

      for (const prodDoc of prodDocs.docs) {
        reviewList.push(prodDoc.data());
      }

      self.Reviews = reviewList;
    }).catch((err: any) => {
      console.error(err);
      this.Reviews = undefined
    });

    setTimeout(() => {
      (window as any).$(`#${this.GetMyId()}`).slick({
        speed: 500,
        infinite: true,
        dots: true,
        arrows: false,
        // fade: true,
        // cssEase: 'linear'
      });
    }, 2000);
  }
}
